module.exports = "https://redage.akamaized.net/src/views/player/help/images/barb2.jpg";